import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import "../data-links.css";

import { Context } from "../../../models/context";

type FieldType = "checkbox" | "text" | "number";

interface Field {
    label: string;
    value: string;
    type: FieldType;
}

const ACTIONS = [
    { label: "Select...", value: "select..." },
    { label: "Search PIDs", value: "Search PIDs" },
    { label: "Search ARKs", value: "Search ARKs"}
];

const ACTION_FIELDS: Record<string, Field[]> = {
    "Search PIDs": [
        { label: "Given Name", value: "given_name", type: "text" },
        { label: "Surname", value: "surname", type: "text" },
        { label: "Birth Place", value: "birth_place", type: "text" },
        { label: "Death Place", value: "death_place", type: "text" },
        { label: "Date From (year)", value: "date_from_year", type: "text"},
        { label: "Date To (year)", value: "date_to_year", type: "text"},
        { label: "Count", value: "count", type: "number"},
        { label: "Offset", value: "offset", type: "number"},
        { label: "Exact Given Name", value: "exact_give_name", type: "checkbox"},
        { label: "Exact Surname", value: "exact_surname", type: "checkbox"},
        { label: "Exact Birth Place", value: "exact_birth_place", type: "checkbox"},
        { label: "Exact Death Place", value: "exact_death_place", type: "checkbox"},
        { label: "Any Place", value: "any_place", type: "text"},
    ],
    
    "Search ARKs": [
        { label: "Given Name", value: "given_name", type: "text" },
        { label: "Surname", value: "surname", type: "text" },
        { label: "Birth Year", value: "birth_year", type: "checkbox" },
        { label: "Birth Date", value: "birth_date", type: "checkbox" },
        { label: "Birth Place", value: "birth_place", type: "checkbox" },
        { label: "Death Year", value: "death_year", type: "checkbox" },
        { label: "Death Place", value: "death_place", type: "checkbox" },
        { label: "Collection ID", value: "collection_id", type: "text"},
        { label: "Count", value: "count", type: "number"},
        { label: "Offset", value: "offset", type: "number"},
        
    ]
}

export default function Search() {
    const context = useContext(Context);
    const navigate = useNavigate();

    const [action, setAction] = useState(ACTIONS[0].value);

    const [fieldValues, setFieldValues] = useState<Record<string, string | boolean>>({});

    useEffect(() => {
        if (!context.user) {
            navigate("/login");
            return;
        }
    });

    useEffect(() => {
        setFieldValues({});
    }, [action]);

    const currentFields = ACTION_FIELDS[action] ?? [];

    const toggleCheckbox = (value: string) => {
        setFieldValues(prev => ({ ...prev, [value]: !prev[value] }));
    };

    const setFieldValue = (value: string, newValue: string) => {
        setFieldValues(prev => ({ ...prev, [value]: newValue}));
    }

    const renderField = (field: Field) => {
        switch (field.type) {
            case "checkbox": 
                return (
                    <label key={field.value} className="checkbox-option" id={field.value}>
                        <input
                            type="checkbox"
                            checked={!!fieldValues[field.value]}
                            onChange={() => toggleCheckbox(field.value)}
                        />
                        {field.label}    
                    </label>
                );
            case "number":
                return (
                    <div key={field.value} className="field-option-no-margin" id={field.value}>
                        <label>{field.label}</label>
                        <input
                            type="number"
                            value={(fieldValues[field.value] as string) ?? ""}
                            onChange={e => setFieldValue(field.value, e.target.value)}
                        />
                    </div>
                );
            case "text":
                return (
                    <div key={field.value} className="field-option-no-margin" id={field.value}>
                        <label>{field.label}</label>
                        <input
                            type="text"
                            value={(fieldValues[field.value] as string) ?? ""}
                            onChange={e => setFieldValue(field.value, e.target.value)}
                        />
                    </div>
                );
            default:
                return null;
        }
    }

    return (
        <div className="data-link-main" >
            <div className="data-link-box container">

                <div className="columns">
                    <div className="data-link-content">
                        <h1>Search</h1>
                        <div className="data-link-section">
                            <div className="circle">
                                <div className="circle-num">
                                    <h2>1</h2>
                                </div>
                            </div>
                            <div className="section-heading">
                                <h2>Upload a .csv file</h2>
                                <input type="file" id="file-upload" className="custom-file-input" accept=".csv" />
                            </div>
                        </div>
                        <div className="data-link-section">
                            <div className="circle">
                                <div className="circle-num">
                                    <h2>2</h2>
                                </div>
                            </div>
                            <div className="section-heading">
                                <h2>Select an action</h2>
                                <select className="dropdown-action" value={action} onChange={e => setAction(e.target.value)}>
                                    {ACTIONS.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="data-link-section">
                            <div className="circle">
                                <div className="circle-num">
                                    <h2>3</h2>
                                </div>
                            </div>
                            <div className="section-heading">
                                <h2>Additional Information</h2>
                                {action === ACTIONS[0].value || currentFields.length === 0 ? (
                                    <p className="no-info">No additional information available</p>
                                ) : (
                                    <>
                                        {currentFields.some(f => f.type === "checkbox") && (
                                            <div className="field-group">
                                                {currentFields
                                                    .filter(f => f.type === "checkbox")
                                                    .map(renderField)}
                                            </div>
                                        )}

                                        <div className="field-list split-columns">
                                            {currentFields
                                                .filter(f => f.type !== "checkbox")
                                                .map(renderField)}
                                        </div>

                                    </>
                                )}
                            </div>
                        </div>
                        {/* TODO: MAKE RUN DATAFINDER ACTUALLY RUN DATAFINDER */}
                        {/* TODO: MAKE RUN DATAFINDER SHOW LOADING WHEN PRESSED */}
                        <div className="data-link-section">
                            <div className="run-data-finder">
                                <button className="run-button" onClick={() => navigate(-1)}>Run DataFinder</button>
                            </div>
                        </div>

                    </div>
                    <div className="preview-wrapper">
                        <div className="preview-view container">
                            <h1>PREVIEW OF CSV</h1>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}